class DialogService {
    constructor($state, $templateCache, modalService, $document, $timeout, $filter) {
        this.$state = $state;
        this.modalService = modalService;
        this.$document = $document;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.dialogController = [
            '$element', 'close', 'cancelText', 'secondaryText', 'primaryText', 'title', 'message', 'notice', 'id',
            function ($element, close, cancelText, secondaryText, primaryText, title, message, notice, id) {
                this.close = result => {
                    $element.find('.modal').modal('hide');
                    close(result, 500);
                };
                this.cancelText = cancelText;
                this.secondaryText = secondaryText;
                this.primaryText = primaryText;
                this.title = title;
                this.message = message;
                this.notice = notice;
                this.id = id;
                this.isMessageNotificationList = !this.notice && this.message instanceof Array;
            }];

        $templateCache.put('dialog.html',
            `<div class="ctx-modal-content message-box">
                <div class="modal fade">
                    <div class="modal-dialog modal-sm">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" ng-click="$ctrl.close(false)" aria-label="this.$filter('translate')('common.form.default.btn.close.label')" aria-hidden="true">
                                   <span aria-hidden="true"><i class="fa fa-times" aria-hidden="true"></i></span>
                                </button>
                                <h4 class="modal-title">{{$ctrl.title}}</h4></div>
                            <div class="modal-body text-center">
                               <div class="row" ng-if="!$ctrl.isMessageNotificationList">
                                   <div class="col-xs-12"><p>{{$ctrl.message}}</p></div>
                                   <div ng-if="$ctrl.notice" class="notice col-xs-12">
                                       <i class="icon icon-warning warning"></i><p>{{$ctrl.notice}}</p>
                                   </div>
                               </div>
                               <div class="row" ng-if="$ctrl.isMessageNotificationList" ng-style="{'padding-bottom': !$last ? '30px' : ''}" ng-repeat="item in $ctrl.message track by $index">
                                   <div class="col-xs-12"><p>{{item.message}}</p></div>
                                   <div ng-if="item.notice" class="notice col-xs-12">
                                       <i class="icon icon-warning warning"></i><p>{{item.notice}}</p>
                                   </div>
                               </div>
                            </div>
                            <div class="modal-footer">
                                <button id="{{$ctrl.id}}-close" style="margin-right: -3px;" type="button" class="btn ctx-btn-secondary btn-close-modal"
                                        ng-click="$ctrl.close()" ng-if="$ctrl.cancelText">{{$ctrl.cancelText}}
                                </button>
                                <button id="{{$ctrl.id}}-no" style="margin-right: -3px;" type="button" class="btn ctx-btn-primary btn-close-modal"
                                        ng-click="$ctrl.close(false)" ng-if="$ctrl.secondaryText">{{$ctrl.secondaryText}}
                                </button>
                                <button id="{{$ctrl.id}}-yes" type="button" class="btn ctx-btn-primary btn-enter-modal" ng-click="$ctrl.close(true)"
                                        ng-if="$ctrl.primaryText">{{$ctrl.primaryText}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>'`
        );
    }

    _showDialog(inputs) {
        const onShow = () => {
            this.$timeout(() => {
                this.$document.find('.modal-backdrop').last().addClass('ctx-message-box');
                this.$document.off('show.bs.modal', '.modal', onShow);
            }, 0);
        };

        const onESCPress = () => {
            this.$timeout(() => {
                this.$document.find('.modal-open .modal-footer .btn-close-modal').click();
            }, 0);
        };

        const onENTERPress = () => {
            this.$timeout(() => {
                this.$document.find('.message-box .modal-footer .btn-enter-modal').click();
            }, 0);
        };

        this.$document.on('show.bs.modal', '.modal', onShow);

        this.$document.off('keydown.modalDialog').on('keydown.modalDialog', e => {
            if (e.keyCode === 27) {
                onESCPress();
            }
            if (e.keyCode === 13) {
                onENTERPress();
            }
        });

        return this.modalService.showModal({
            templateUrl: 'dialog.html',
            controller: this.dialogController,
            controllerAs: '$ctrl',
            inputs
        }).then(dialog => {
            dialog.element.find('.modal').modal({ show: true, backdrop: 'static', keyboard: false });
            return dialog.close;
        });
    }

    showInfo(message, notice, id) {
        return this._showDialog({
            cancelText: null,
            secondaryText: null,
            primaryText: this.$filter('translate')('utils.dialog.default.btn.primary.text'),
            title: this.$filter('translate')('utils.dialog.info.title'),
            message,
            id,
            notice
        });
    }

    showWarning(message, title, notice, id) {
        return this._showDialog({
            cancelText: null,
            secondaryText: null,
            primaryText: this.$filter('translate')('utils.dialog.default.btn.primary.text'),
            title: title || this.$filter('translate')('utils.dialog.title.warning.text'),
            message,
            id,
            notice
        });
    }

    showError(message, title, notice, id) {
        return this._showDialog({
            primaryText: this.$filter('translate')('utils.dialog.default.btn.primary.text'),
            title: title || this.$filter('translate')('utils.dialog.title.error.text'),
            message,
            id,
            notice
        });
    }

    showConfirm(message, title, notice, id) {
        return this._showDialog({
            cancelText: null,
            secondaryText: this.$filter('translate')('utils.dialog.default.btn.secondary.text'),
            primaryText: this.$filter('translate')('utils.dialog.default.btn.primary.text'),
            title: title || 'Confirm',
            message,
            id,
            notice
        });
    }

    showYesNo(message, title, notice, id, cancelButton) {
        return this._showDialog({
            cancelText: cancelButton ? this.$filter('translate')('utils.dialog.yesNo.btn.cancel.text') : null,
            secondaryText: this.$filter('translate')('utils.dialog.yesNo.btn.secondary.text'),
            primaryText: this.$filter('translate')('utils.dialog.yesNo.btn.primary.text'),
            title: title || this.$filter('translate')('utils.dialog.title.proceed.text'),
            message,
            id,
            notice
        });
    }
}

DialogService.$inject = ['$state', '$templateCache', 'ModalService', '$document', '$timeout', '$filter'];

module.exports = DialogService;


// WEBPACK FOOTER //
// ./src/shared/utils/dialog.service.js